import { RendererWidgetContainerRegistry } from './rendererWidgetContainerRegistry';
import { WidgetContainerImpl } from './WidgetContainer/impl';
import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { ReactBindings } from 'src/types/bindings';

/** Window-local bindings for the WidgetContainers that own rendered widget models. */
export const widgetContainerModule = new TypedContainerModule<ReactBindings>((bind) => {
    bind('RendererWidgetContainerRegistry').to(RendererWidgetContainerRegistry).inSingletonScope();
    bind('WidgetContainer').to(WidgetContainerImpl);
    bind('WidgetContainerFactory')
        .toDynamicValue((context) => () => context.container.get('WidgetContainer'))
        .inSingletonScope();
});
